export const ChangeActionOptionPolicy = ({
    actionOption: {
        CREATE_DUMMY_VOY_CNTR: "Create Dummy Voy and Cntr as TS 1st Leg",
        CREATE_DUMMY_CNTR: "Create Dummy Cntr as TS 1st Leg",
        MAP_EXISTING_TS_LEG: "Map Existing TS Leg",
        CHANGE_CNTR_STATUS_ONLY: "Change Cntr Status Only"
    },
    chargeType: {
        CHANGE_TYPE_1: "changeType1",
        CHANGE_TYPE_2: "changeType2",
        CHANGE_TYPE_3: "changeType3",
        CHANGE_TYPE_4: "changeType4",
        CHANGE_TYPE_5: "changeType5",
    }
});